import React, { useEffect, useState } from "react";
import { cognitoLoginOAuth, foundryLogin } from "../../service/foundryService";
import { useNavigate  } from "react-router-dom";
import { useDispatch } from "react-redux";
import { cognitoLoginSuccess } from "../../store/store";
const ClientCredientialsLogin = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    if (params.get("code")) {
      handleCognitoLogin(params)
    }
  }, []);
  const handleCognitoLogin = async (params) =>{
      try {
        let data = await cognitoLoginOAuth(params)
        let token = data.id_token
        let timeout = data.expires_in * 1000 + Date.now();
        dispatch(cognitoLoginSuccess({ token, timeout }));
        return navigate("/login")
        
      } catch (error) {
        console.error("401-Unauthorized")
      }
  }
  return ;
};


export default ClientCredientialsLogin;
